/**
 * Disponibilité des portefeuilles (Apple Pay, Google Pay) côté appareil.
 *
 * Ce module a d'abord réservé Apple Pay aux appareils Apple et Google Pay à
 * Android, sur la foi d'essais où la page de paiement hébergée refusait les
 * deux sur un navigateur de bureau. Ces essais étaient faussés : le jeton de
 * paiement, copié à la main pour les besoins du test, arrivait abîmé. Rejoués
 * le 24/09/2026 avec un lien intact, ils donnent l'inverse :
 *
 *   - Apple Pay payé et encaissé depuis Chrome sur macOS (vente 920439,
 *     transaction 188839, Approved et Settled) ;
 *   - Google Pay payé et encaissé depuis Chrome sur macOS (vente 920165,
 *     transaction 188736) ;
 *   - la page propose même les deux sous Firefox, que la documentation de
 *     Stripe donne pourtant pour incompatible.
 *
 * En production le problème n'existe pas : c'est le serveur qui redirige le
 * navigateur, personne ne recopie de jeton. Le filtrage par navigateur n'a
 * donc plus lieu d'être, et il coûtait des paiements.
 *
 * Reste une exclusion de bon sens, la seule : un appareil ne peut pas
 * présenter le portefeuille du système d'en face. Elle évite au client un
 * aller-retour inutile vers une page qui ne saura rien lui proposer.
 */

function ua(): string {
  try {
    return navigator.userAgent ?? '';
  } catch {
    return '';
  }
}

const isAndroid = () => /android/i.test(ua());
const isIos = () => /iphone|ipad|ipod/i.test(ua());

/** Apple Pay : partout sauf sur un Android, qui n'a pas de portefeuille Apple. */
export function isApplePayCapable(): boolean {
  return !isAndroid();
}

/** Google Pay : partout sauf sur iOS et iPadOS, où il n'est pas proposé sur le web. */
export function isGooglePayCapable(): boolean {
  return !isIos();
}
